import React from "react";
import { Form as BootstrapForm } from "react-bootstrap";
import { recursiveChildrenMap } from "shared/utils/recursiveChildrenMap";
import Check from "../Check/Check";
import DateTimePicker from "../DateTimePicker/DateTimePicker";
import Input from "../Input/Input";
import NumericInput from "../NumericInput/NumericInput";
import Select from "../Select/Select";
import { FilesInput } from "features/FilesInput";

function Form({ form, onSubmit = () => {}, children, ...props }) {
  const {
    register,
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = form;
  return (
    <BootstrapForm onSubmit={handleSubmit(onSubmit)} {...props}>
      {recursiveChildrenMap(children, (child) => {
        return child.props.name
          ? React.createElement(child.type, {
              ...{
                ...child.props,
                register,
                control,
                setValue,
                error: errors[child.props.name],
                key: child.props.name,
              },
            })
          : child;
      })}
    </BootstrapForm>
  );
}

Form.Input = Input;
Form.Check = Check;
Form.Select = Select;
Form.DateTimePicker = DateTimePicker;
Form.FilesInput = FilesInput;
Form.NumericInput = NumericInput;

export default Form;
